export const INQUIRY_STATUS_LABELS: Record<string, string> = {
  NEW: "Új",
  PENDING: "Folyamatban",
  "OFFER SENT": "Ajánlat elküldve",
  "OFFER ACCEPTED": "Ajánlat elfogadva",
  COMPLETED: "Teljesítve",
  BOOKED: "Lefoglalva",
  CANCELLED: "Törölve",
};

/**
 * The statuses that close an inquiry, mirroring InquiryStatus.isTerminal on the backend. Used
 * to hide what the server would refuse anyway -- the server stays the authority.
 */
export const TERMINAL_INQUIRY_STATUSES = [
  "OFFER ACCEPTED",
  "COMPLETED",
  "BOOKED",
  "CANCELLED",
];

export const OFFER_STATUS_LABELS: Record<string, string> = {
  DRAFT: "Piszkozat",
  PENDING: "Függőben",
  ACCEPTED: "Elfogadva",
  REJECTED: "Elutasítva",
  INVALIDATED: "Érvénytelen",
};

export const BOOKING_STATUS_LABELS: Record<string, string> = {
  BOOKED: "Lefoglalva",
  COMPLETED: "Teljesítve",
  CANCELLED: "Törölve",
};

export const PLACEMENT_TYPE_LABELS: Record<string, string> = {
  SINGLE_ROOM: "Egyágyas szoba",
  DOUBLE_ROOM: "Kétágyas szoba",
  OTHER: "Egyéb",
};

export const inquiryStatusLabel = (status: string): string =>
  INQUIRY_STATUS_LABELS[status] ?? status;

export const placementTypeLabel = (placementType: string): string =>
  PLACEMENT_TYPE_LABELS[placementType] ?? placementType ?? "";

export const bookingStatusLabel = (status: string): string =>
  BOOKING_STATUS_LABELS[status] ?? status;

export const offerStatusLabel = (status: string): string =>
  OFFER_STATUS_LABELS[status] ?? status;

export const isTerminalInquiryStatus = (status: string): boolean =>
  TERMINAL_INQUIRY_STATUSES.includes(status);
